import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punerailwaystationcabservice() {



  const cardData = {




keyword: "Pune Railway Station Cab Service",

headingDescription: "Garud Cab Service provides reliable and comfortable Pune Railway Station Cab Service for passengers arriving at or departing from Pune Railway Station. Our chauffeur-driven cabs are suitable for railway station pickup and drop, family travel, business trips, hotel transfers, local sightseeing, and outstation journeys. Customers can book Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles according to their travel requirements. With experienced drivers, clean and well-maintained cars, flexible pickup timings, convenient luggage space, transparent pricing, and 24/7 customer assistance, Garud Cab Service offers smooth railway station transportation from Pune to popular destinations across Maharashtra and nearby states.",

topPlaces: [
  {
    title: "Mumbai",
    description: "Mumbai is a major destination from Pune for business meetings, family visits, shopping, entertainment, airport connections, and professional travel. Passengers arriving at Pune Railway Station can continue their journey to Mumbai in a comfortable private cab without depending on connecting public transport. Garud Cab Service provides convenient one-way and round-trip cab options with flexible pickup arrangements."
  },
  {
    title: "Nashik",
    description: "Nashik is a popular destination from Pune known for its temples, vineyards, business activities, and cultural attractions. Travelers arriving at Pune Railway Station can book a private cab for direct transportation to Nashik with convenient door-to-door service. The journey is suitable for families, couples, business travelers, and devotees who prefer comfortable chauffeur-driven transportation."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is an important destination in southern Maharashtra known for its temples, heritage attractions, traditional culture, and commercial activities. Passengers arriving by train in Pune can continue their journey by private cab for greater flexibility and comfort. Garud Cab Service offers suitable vehicles for individuals, families, and small groups traveling toward Kolhapur."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for scenic viewpoints, valleys, lakes, waterfalls, and pleasant mountain surroundings. Travelers arriving at Pune Railway Station can directly book a cab for a comfortable onward journey to the hill station. Customers can choose one-way or return travel and include nearby sightseeing locations according to their preferred itinerary."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination visited by devotees throughout the year for Sai Baba Darshan. Passengers arriving at Pune Railway Station can conveniently continue their religious journey by private cab. Garud Cab Service provides chauffeur-driven transportation suitable for families, senior citizens, and small groups, with flexible travel schedules and convenient pickup arrangements."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance destination from Pune for beach holidays, family vacations, group travel, and weekend breaks. Travelers arriving at Pune Railway Station can book a private cab for onward road travel with comfortable seating and luggage space. Garud Cab Service offers one-way and round-trip options for passengers who prefer a personalized journey toward Goa."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is an important destination for heritage tourism, business travel, family visits, and religious journeys. Travelers can continue from Pune Railway Station toward the city using a private chauffeur-driven cab. Garud Cab Service provides comfortable transportation for individuals, families, and groups with flexible pickup and drop arrangements."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination known for beaches, forts, sea views, and relaxed weekend getaways. Passengers arriving at Pune Railway Station can choose a private cab for convenient road travel toward the Konkan coast. A chauffeur-driven vehicle allows families and couples to travel comfortably while also providing flexibility to visit nearby beaches and attractions."
  },
  {
    title: "Solapur",
    description: "Solapur is an important commercial and industrial city in Maharashtra and is visited for business work, family functions, education, and personal travel. Passengers arriving at Pune Railway Station can book a private cab for direct transportation to Solapur. Garud Cab Service provides comfortable vehicles, professional drivers, and flexible one-way or round-trip travel arrangements."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a peaceful nature destination surrounded by mountains, forests, lakes, and waterfalls, making it suitable for weekend trips and relaxed family holidays. Travelers arriving in Pune can continue toward Bhandardara by private cab for a more flexible journey. Customers can customize their travel plan to include nearby attractions and scenic stops along the route."
  }
],



"services": [
{
"name": "Pune Railway Station Cab",
"description": "Book Pune Railway Station Cab for convenient pickup and drop transportation to and from Pune Railway Station. Enjoy professional chauffeurs, clean AC vehicles, comfortable seating, and flexible travel options for passengers, families, business travelers, tourists, and customers continuing to local or outstation destinations."
},
{
"name": "Cab Near Pune Railway Station",
"description": "Choose Cab Near Pune Railway Station for quick and convenient transportation from locations around Pune Junction. The service is suitable for railway passengers, families, tourists, office travelers, and individuals requiring comfortable AC cabs for hotel transfers, local travel, airport connections, or outstation journeys."
},
{
"name": "Taxi at Pune Station",
"description": "Book Taxi at Pune Station for reliable transportation immediately after arriving at Pune Railway Station. Professional chauffeurs, comfortable AC vehicles, convenient pickup arrangements, and multiple vehicle options make the service suitable for local transfers, hotel drops, airport travel, and outstation trips."
},
{
"name": "Railway Pickup Drop Pune",
"description": "Arrange Railway Pickup Drop Pune for scheduled transportation to or from Pune Railway Station with convenient door-to-door service. Comfortable AC vehicles and professional chauffeurs are available for individuals, families, senior passengers, corporate travelers, and tourists carrying luggage."
},
{
"name": "Cab from Pune Railway Station",
"description": "Hire a Cab from Pune Railway Station for comfortable private transportation to your home, hotel, office, airport, or preferred outstation destination. Choose suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options according to passenger and luggage requirements."
},
{
"name": "Pune Station Taxi Service",
"description": "Choose Pune Station Taxi Service for dependable pickup and drop transportation around Pune Railway Station. The service provides comfortable AC travel with professional chauffeurs for railway transfers, hotel transportation, airport connections, business travel, family journeys, and local or outstation trips."
},
{
"name": "Affordable Station Cab Pune",
"description": "Book Affordable Station Cab Pune for convenient and budget-friendly transportation from Pune Railway Station. Select an economical sedan or spacious MUV and enjoy comfortable AC travel, professional chauffeur service, convenient pickup, and direct destination drop for local and outstation journeys."
},
{
"name": "24 Hour Station Cab Pune",
"description": "Choose 24 Hour Station Cab Pune for convenient railway station transportation at different travel timings. The service is suitable for early morning arrivals, late-night departures, business travelers, families, tourists, and passengers requiring scheduled pickup or drop from Pune Railway Station."
},
{
"name": "Local Cab Near Station Pune",
"description": "Book Local Cab Near Station Pune for comfortable transportation between Pune Railway Station and nearby residential, commercial, hotel, and business locations. Enjoy convenient pickup, professional chauffeurs, clean AC vehicles, and flexible travel arrangements for short-distance city journeys."
},
{
"name": "Station Transfer Taxi Pune",
"description": "Arrange Station Transfer Taxi Pune for smooth transportation between Pune Railway Station and hotels, offices, residential areas, Pune Airport, or other destinations. Comfortable AC vehicles and experienced chauffeurs provide convenient private travel for individuals, families, tourists, and corporate passengers."
},
{
"name": "Best Cab Pune Railway Station",
"description": "Choose Best Cab Pune Railway Station for comfortable and dependable railway transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for station pickup, destination drop, airport transfers, hotel transportation, local travel, and outstation journeys."
},
{
"name": "Budget Station Taxi Pune",
"description": "Book Budget Station Taxi Pune for economical transportation to and from Pune Railway Station. Choose a practical sedan or suitable family vehicle according to your passenger count and luggage requirements while enjoying comfortable AC interiors, professional chauffeur service, and convenient pickup and drop."
},
{
"name": "Instant Cab Railway Station Pune",
"description": "Arrange Instant Cab Railway Station Pune for convenient transportation when you need a cab around Pune Railway Station. Suitable vehicle options are available for individuals, couples, families, and groups requiring quick local transfers, hotel drops, airport connections, or outstation travel."
},
{
"name": "Sedan Cab Station Pune",
"description": "Book Sedan Cab Station Pune for comfortable railway station transportation with a practical AC sedan and professional chauffeur. The service is suitable for individuals, couples, small families, business travelers, and tourists requiring station pickup, hotel transfers, airport travel, or outstation transportation."
},
{
"name": "SUV Cab Pune Station",
"description": "Choose SUV Cab Pune Station for spacious and comfortable railway station transportation for families and groups carrying additional luggage. Enjoy air-conditioned interiors, generous seating, professional chauffeur service, convenient pickup, and flexible travel options for local and outstation destinations."
},
{
"name": "Pune Railway Station Cab for Outstation",
"description": "Book Pune Railway Station Cab for Outstation travel for direct transportation from Pune Junction to destinations across Maharashtra and nearby states. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV vehicles for comfortable long-distance journeys with professional chauffeur service."
},
{
"name": "Outstation Cab from Pune Railway Station",
"description": "Choose Outstation Cab from Pune Railway Station for convenient long-distance travel immediately after arriving by train. Enjoy scheduled station pickup, luggage-friendly AC vehicles, professional chauffeurs, and suitable vehicle choices for one-way, round-trip, family, business, and sightseeing journeys."
},
{
"name": "Pune Station Taxi Service for Outstation",
"description": "Book Pune Station Taxi Service for Outstation travel with convenient pickup directly from Pune Railway Station. Comfortable AC vehicles and experienced chauffeurs are available for families, couples, tourists, corporate travelers, and groups planning one-way or round-trip journeys to destinations outside Pune."
},
{
"name": "Railway Station Outstation Cab Pune",
"description": "Choose Railway Station Outstation Cab Pune for direct transportation from Pune Railway Station to your preferred destination. The service provides comfortable chauffeur-driven vehicles with luggage space and flexible travel arrangements for long-distance family trips, business travel, sightseeing, and personal journeys."
},
{
"name": "Pune Junction Outstation Cab Booking",
"description": "Make Pune Junction Outstation Cab Booking for scheduled pickup from Pune Railway Station and convenient travel to destinations outside the city. Select a suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your passenger count and luggage requirements."
},
{
"name": "Pune Railway Station Taxi Booking",
"description": "Reserve Pune Railway Station Taxi Booking for convenient pickup and drop transportation around Pune Junction. Plan your travel according to train arrival or departure timings and enjoy comfortable AC vehicles, professional chauffeurs, luggage assistance, and local or outstation travel options."
},
{
"name": "Best Outstation Cab from Pune Station",
"description": "Choose Best Outstation Cab from Pune Station for comfortable long-distance transportation directly from Pune Railway Station. Professional chauffeurs, well-maintained AC vehicles, spacious seating, luggage capacity, and flexible one-way or round-trip options make the service suitable for families, groups, tourists, and business travelers."
},
{
"name": "24x7 Pune Railway Station Cab",
"description": "Book 24x7 Pune Railway Station Cab for convenient transportation at different hours according to your train schedule. The service supports early morning pickups, late-night arrivals, station drops, airport connections, hotel transfers, local journeys, and outstation travel with comfortable chauffeur-driven vehicles."
},
{
"name": "Cheap Outstation Cab Pune Railway Station",
"description": "Choose Cheap Outstation Cab Pune Railway Station for economical long-distance transportation from Pune Junction. Select an affordable sedan or spacious vehicle according to your group size and enjoy private AC travel, professional chauffeur service, convenient railway pickup, and direct destination drop."
},
{
"name": "Pune Station to Mumbai Cab Service",
"description": "Book Pune Station to Mumbai Cab Service for direct transportation from Pune Railway Station to Mumbai. Enjoy convenient railway pickup, professional chauffeur service, comfortable AC vehicles, luggage space, and suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for one-way or round-trip travel."
},
{
"name": "Best Outstation Cab Near Pune Railway Station",
"description": "Choose Best Outstation Cab Near Pune Railway Station for convenient long-distance travel starting from Pune Junction. Comfortable AC vehicles, experienced chauffeurs, luggage-friendly seating, and flexible one-way or round-trip arrangements make the service suitable for families, tourists, corporate travelers, and groups."
},
{
"name": "Cheap Taxi from Pune Station",
"description": "Book Cheap Taxi from Pune Station for economical transportation to local and outstation destinations after arriving at Pune Railway Station. Choose a suitable vehicle according to your passenger and luggage requirements while enjoying comfortable AC travel and professional chauffeur service."
},
{
"name": "Book Outstation Cab from Pune Railway Station",
"description": "Book Outstation Cab from Pune Railway Station for convenient direct travel to destinations outside Pune. Schedule your pickup around your train arrival and choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV vehicles for comfortable family trips, business travel, sightseeing, and personal journeys."
},
{
"name": "Safe Cab Service Pune Station",
"description": "Choose Safe Cab Service Pune Station for comfortable and dependable railway transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for families, women travelers, senior passengers, tourists, business travelers, and individuals requiring convenient local or outstation transportation."
},
{
"name": "Railway Station Pickup Cab Pune",
"description": "Book Railway Station Pickup Cab Pune for convenient pickup directly from Pune Railway Station according to your train arrival. Professional chauffeurs can assist with luggage while providing comfortable AC transportation to homes, hotels, offices, airports, and outstation destinations."
},
{
"name": "Cab from Pune Junction to Mumbai",
"description": "Reserve Cab from Pune Junction to Mumbai for a comfortable private journey starting directly from Pune Railway Station. Choose a Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your group size and luggage requirements for convenient one-way or return travel."
},
{
"name": "Family Outstation Taxi Pune Station",
"description": "Choose Family Outstation Taxi Pune Station for spacious and comfortable long-distance travel starting from Pune Railway Station. Family-friendly vehicle options, professional chauffeurs, AC interiors, luggage space, and convenient station pickup make the service suitable for holidays, visits, and sightseeing trips."
},
{
"name": "24 Hour Taxi Near Pune Station",
"description": "Book 24 Hour Taxi Near Pune Station for convenient transportation around Pune Railway Station at flexible timings. The service is suitable for train arrivals, early morning departures, late-night travel, airport transfers, hotel drops, local rides, and outstation journeys with comfortable chauffeur-driven vehicles."
}
],
"tableData": [
["Pune Railway Station Cab", "Cab Near Pune Railway Station"],
["Taxi at Pune Station", "Railway Pickup Drop Pune"],
["Cab from Pune Railway Station", "Pune Station Taxi Service"],
["Affordable Station Cab Pune", "24 Hour Station Cab Pune"],
["Local Cab Near Station Pune", "Station Transfer Taxi Pune"],
["Best Cab Pune Railway Station", "Budget Station Taxi Pune"],
["Instant Cab Railway Station Pune", "Sedan Cab Station Pune"],
["SUV Cab Pune Station", "Pune Railway Station Cab for Outstation"],
["Outstation Cab from Pune Railway Station", "Pune Station Taxi Service for Outstation"],
["Railway Station Outstation Cab Pune", "Pune Junction Outstation Cab Booking"],
["Pune Railway Station Taxi Booking", "Best Outstation Cab from Pune Station"],
["24x7 Pune Railway Station Cab", "Cheap Outstation Cab Pune Railway Station"],
["Pune Station to Mumbai Cab Service", "Best Outstation Cab Near Pune Railway Station"],
["Cheap Taxi from Pune Station", "Book Outstation Cab from Pune Railway Station"],
["Safe Cab Service Pune Station", "Railway Station Pickup Cab Pune"],
["Cab from Pune Junction to Mumbai", "Family Outstation Taxi Pune Station"],
["24 Hour Taxi Near Pune Station", ""]
],



whychoose: [
  {
    WhyChooseheading: "Pune Railway Station Cab Service for Easy Transfers",
    WhyChoosedescription: "Garud Cab Service provides private cab transportation to and from Pune Railway Station for passengers arriving in the city, catching trains, travelling with families, or carrying luggage."
  },
  {
    WhyChooseheading: "Convenient Pickup & Drop Arrangements",
    WhyChoosedescription: "Book a cab for direct pickup from Pune Railway Station or arrange a drop from your home, hotel, office, airport, or another preferred location according to your train schedule."
  },
  {
    WhyChooseheading: "Useful for Early & Late Train Journeys",
    WhyChoosedescription: "Railway travel often involves early departures and late arrivals, so you can arrange your cab around your planned train timing and avoid the inconvenience of searching for transportation after reaching the station."
  },
  {
    WhyChooseheading: "Comfortable Travel with Luggage",
    WhyChoosedescription: "Private cabs provide a convenient option for passengers travelling with suitcases, family luggage, business bags, or other belongings that may be difficult to manage with multiple local transfers."
  },
  {
    WhyChooseheading: "Suitable for Families & Senior Citizens",
    WhyChoosedescription: "Families and senior passengers can travel directly between the railway station and their destination with a private vehicle, reducing unnecessary walking, transfers, and waiting."
  },
  {
    WhyChooseheading: "Airport, Hotel & Railway Station Connectivity",
    WhyChoosedescription: "Combine your railway journey with airport transfers, hotel pickups, office travel, or local transportation by arranging a cab between Pune Railway Station and your required destination."
  },
  {
    WhyChooseheading: "Local & Outstation Connections",
    WhyChoosedescription: "The service can also support passengers continuing their journey from Pune Railway Station to nearby cities, business locations, tourist destinations, or other outstation areas."
  },
  {
    WhyChooseheading: "Advance Booking with Garud Cab Service",
    WhyChoosedescription: "Share your train arrival or departure time, pickup or drop location, passenger count, luggage details, and preferred vehicle with Garud Cab Service to arrange your railway station cab."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune Railway Station Cab Service?",
    answer: "Yes, Garud Cab Service provides cab services for Pune Railway Station pickup and drop, including transportation for families, business travellers, tourists, and passengers carrying luggage."
  },
  {
    question: "Can I book a cab for Pune Railway Station pickup?",
    answer: "Yes, you can arrange a private cab to pick you up from Pune Railway Station and take you to your home, hotel, office, airport, or another preferred destination."
  },
  {
    question: "Can I book a cab to drop me at Pune Railway Station?",
    answer: "Yes, cab service can be arranged from your home, hotel, office, airport, or another Pune location to Pune Railway Station according to your train timing."
  },
  {
    question: "Can I book a cab for an early-morning train?",
    answer: "Yes, advance cab booking can be requested for early-morning train departures based on your required pickup time and vehicle availability."
  },
  {
    question: "Can I arrange a cab for a late-night train arrival?",
    answer: "Yes, railway station pickup can be scheduled around your expected arrival time so you can continue your journey conveniently."
  },
  {
    question: "Is Pune Railway Station cab service suitable for families?",
    answer: "Yes, families can book a private vehicle according to their passenger count and luggage requirements for convenient station transfers."
  },
  {
    question: "Can senior citizens use the railway station cab service?",
    answer: "Yes, private cab transportation can be convenient for senior citizens by providing direct travel between the station and their preferred destination."
  },
  {
    question: "Can I book a cab from Pune Railway Station to Pune Airport?",
    answer: "Yes, cab transportation can be arranged between Pune Railway Station and Pune Airport based on your train arrival, flight schedule, and preferred pickup time."
  },
  {
    question: "Can I travel from Pune Railway Station to an outstation destination?",
    answer: "Yes, suitable outstation cab arrangements can be planned from Pune Railway Station to your selected destination depending on the route and vehicle availability."
  },
  {
    question: "How can I book a Pune Railway Station Cab?",
    answer: "Share your train arrival or departure time, pickup or drop location, passenger details, luggage requirements, and preferred vehicle with Garud Cab Service to arrange your booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Jadhav",
    feedback: "I booked a cab from Pune Railway Station after arriving late in the evening. The private transfer was convenient and saved me the trouble of arranging local transportation with luggage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Joshi",
    feedback: "Our family booked a station drop for an early train. The advance arrangement made our morning travel much easier, especially with children and luggage.",
    rating: 5
  }
];


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Railway Station Cab Service",
  "image": "https://garudcabs.com/assets/images/pune-railway-station-cab-service.webp",
  "description": "Book Pune Railway Station Cab Service with Garud Cab for safe, comfortable, and convenient railway station transfers. Get reliable pickup and drop taxi services from Pune Railway Station to the airport, hotels, offices, residential areas, and outstation destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-railway-station-cab-service"
  }
};





  return (
    <div>
<Helmet>
  <title>Pune Railway Station Cab Service | Pickup & Drop Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune Railway Station Cab Service with Garud Cab for reliable railway pickup and drop. Get taxi services from Pune Railway Station to the airport, hotels, offices, and outstation destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs."
  />

  <meta
    name="keywords"
    content="Pune Railway Station Cab, Cab Near Pune Railway Station, Taxi at Pune Station, Railway Pickup Drop Pune, Cab from Pune Railway Station, Pune Station Cab Service, Pune Railway Station Taxi, Pune Railway Station Pickup Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punerailwaystationcabservice;